var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11C16.6739 11 15.4021 11.5268 14.4645 12.4645C13.5268 13.4021 13 14.6739 13 16C13 17.3261 13.5268 18.5979 14.4645 19.5355C15.4021 20.4732 16.6739 21 18 21C19.3261 21 20.5979 20.4732 21.5355 19.5355C22.4732 18.5979 23 17.3261 23 16C23 14.6739 22.4732 13.4021 21.5355 12.4645C20.5979 11.5268 19.3261 11 18 11ZM20.8506 17.822L19.8214 18.8512L18 17.0292L16.178 18.8506L15.1488 17.8214L16.9714 16L15.1494 14.178L16.1786 13.1494L18 14.9708L19.822 13.1488L20.8512 14.178L19.0286 16L20.8506 17.822Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49949 1.58667C2.49949 0.710379 3.2064 0 4.07843 0H15.9205C16.7926 0 17.4995 0.710378 17.4995 1.58667V10.0206C16.9487 10.0661 16.419 10.1859 15.9205 10.3701V6.74337H4.07843V14.2801H12.2502C12.0874 14.8249 12 15.4022 12 16H0.789474C0.353459 16 0 15.6448 0 15.2067C0 14.7685 0.353459 14.4133 0.789474 14.4133H2.49949V1.58667Z",
    fill: "#575757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0274 11.5034C13.6327 11.8524 13.2843 12.2525 12.9926 12.6934H5.85475C5.52774 12.6934 5.26264 12.427 5.26264 12.0984C5.26264 11.7698 5.52774 11.5034 5.85475 11.5034H14.0274Z",
    fill: "#575757"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1442 9.52005C14.4712 9.52005 14.7363 9.25365 14.7363 8.92504C14.7363 8.59643 14.4712 8.33004 14.1442 8.33004H5.85475C5.52774 8.33004 5.26264 8.59643 5.26264 8.92504C5.26264 9.25365 5.52774 9.52005 5.85475 9.52005H14.1442Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDoor);
export default __webpack_public_path__ + "static/media/NoDoor.761e4bed93df581a22be637977228ca8.svg";
export { ForwardRef as ReactComponent };